<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <b-container>
        <h1>
          Ops, algo deu errado…
        </h1>
        <h2>
          Página não encontrada
        </h2>
        <a
          :href="redirect"
          class="go-home"
        > Voltar para página inicial </a>
      </b-container>
    </div>
  </div>
<!-- / Error page-->
</template>

<script>
import { BContainer } from 'bootstrap-vue'
import { getHomeRoute } from '@/utils/home-route'

export default {
  components: { BContainer },
  data() {
    return {
      redirect: null,
    }
  },

  created() {
    const token = sessionStorage.getItem('token')
    if (token === null) {
      this.redirect = '/'
    } else {
      this.redirect = getHomeRoute()
    }
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
